export default __webpack_public_path__ + "static/media/i_restaurant_medium_grey.a9bd54c2.png";